import { cn, getText } from "shared/lib";
import {
  TreePropertyIcon,
  TreePropertyType,
  type TreePropertyDescriptor,
} from "../lib";

export interface TreeItemPropertyProps {
  className?: string;
  propertyDescriptor: TreePropertyDescriptor;
}

export function TreeItemProperty({
  className,
  propertyDescriptor,
}: TreeItemPropertyProps) {
  const Icon = TreePropertyIcon[propertyDescriptor.propertyType];

  const renderValue = () => {
    switch (propertyDescriptor.propertyType) {
      case TreePropertyType.distance:
      case TreePropertyType.dbh:
        return propertyDescriptor.value !== undefined &&
          propertyDescriptor.value !== null &&
          propertyDescriptor.value !== ""
          ? `${propertyDescriptor.value}m`
          : "";

      case TreePropertyType.circumference:
        if (
          propertyDescriptor.value !== undefined &&
          propertyDescriptor.value !== null &&
          propertyDescriptor.value !== ""
        ) {
          let circumference = `${propertyDescriptor.value}m`;
          if (
            propertyDescriptor.value !== undefined &&
            propertyDescriptor.value !== null &&
            propertyDescriptor.value !== ""
          ) {
            circumference += `, ${propertyDescriptor.groundLevelCircumference}m`;
          }
          return circumference;
        }
        return "";

      case TreePropertyType.height:
        return propertyDescriptor.value !== undefined &&
          propertyDescriptor.value !== null &&
          propertyDescriptor.value !== ""
          ? `${propertyDescriptor.value}m`
          : "";

      case TreePropertyType.lop_prune_percentage:
        return propertyDescriptor.value !== undefined &&
          propertyDescriptor.value !== null &&
          propertyDescriptor.value !== ""
          ? `${parseFloat(propertyDescriptor.value) * 100}%`
          : "";

      case TreePropertyType.trunk_type:
        if (propertyDescriptor.value === "multi") {
          return getText("multi");
        } else if (propertyDescriptor.value === "single") {
          return getText("single");
        }
        return propertyDescriptor.value;

      case TreePropertyType.species:
        if (propertyDescriptor.value === "native") {
          return getText("native");
        } else if (propertyDescriptor.value === "exotic") {
          return getText("exotic");
        } else if (propertyDescriptor.value === "unsure") {
          return getText("unsure");
        }

        return propertyDescriptor.value;

      case TreePropertyType.location:
        if (propertyDescriptor.value === "on site") {
          return getText("on site");
        } else if (propertyDescriptor.value === "off site") {
          return getText("off site");
        }
        return propertyDescriptor.value;

      case TreePropertyType.size:
        if (propertyDescriptor.value === "small") {
          return getText("small");
        } else if (propertyDescriptor.value === "medium") {
          return getText("medium");
        } else if (propertyDescriptor.value === "large") {
          return getText("large");
        }

        return propertyDescriptor.value;

      case TreePropertyType.remove_or_prune:
        if (propertyDescriptor.value === "remove") {
          return getText("remove");
        } else if (propertyDescriptor.value === "prune") {
          return getText("prune");
        }

        return propertyDescriptor.value;

      case TreePropertyType.canopy_size:
        return propertyDescriptor.value !== undefined &&
          propertyDescriptor.value !== null &&
          propertyDescriptor.value !== ""
          ? `> 4m ${propertyDescriptor.value}`
          : "";

      default:
        return propertyDescriptor.value;
    }
  };

  return (
    <div
      className={cn(
        "text-bodysm flex items-center gap-1 text-ellipsis whitespace-nowrap",
        propertyDescriptor.value ? "text-textPrimary" : "text-textDisabled",
        className,
      )}
    >
      {Icon ? <Icon className="h-3 w-3" /> : null}{" "}
      {propertyDescriptor.value
        ? renderValue()
        : propertyDescriptor.placeholder}
    </div>
  );
}
